// The itinerary being followed (Figma C5 → C7 → ride): kept on the device so the step banner and
// the planned parking survive a relaunch. Solid-free (tested); the screens read it at mount.
import type { ItineraryPlan } from "../itinerary";

type Store = Pick<Storage, "getItem" | "setItem" | "removeItem">;
const KEY = "itinerary";

const storage = (): Store | undefined => {
  try {
    return globalThis.localStorage;
  } catch {
    return undefined;
  }
};

const isPlace = (p: unknown) =>
  !!p &&
  typeof (p as { name?: unknown }).name === "string" &&
  typeof (p as { position?: { lat?: unknown } }).position?.lat === "number";

/** Saved without the route geometry (redrawn from the direction API); undefined clears it. */
export function saveFollowed(plan: ItineraryPlan | undefined, store = storage()): void {
  try {
    if (!plan) return store?.removeItem(KEY);
    const lean = (l: ItineraryPlan["walk"]) => ({ sec: l.sec, meters: l.meters, path: [] });
    store?.setItem(
      KEY,
      JSON.stringify({
        ...plan,
        walk: lean(plan.walk),
        ride: lean(plan.ride),
        last: lean(plan.last),
      }),
    );
  } catch {
    // blocked storage: followed for this visit only
  }
}

export function loadFollowed(store = storage()): ItineraryPlan | undefined {
  try {
    const raw = store?.getItem(KEY);
    if (!raw) return undefined;
    const p = JSON.parse(raw) as Partial<ItineraryPlan>;
    const ok =
      isPlace(p.from) &&
      isPlace(p.to) &&
      typeof p.bike?.vehicleId === "string" &&
      typeof p.parking?.id === "string" &&
      typeof p.ride?.sec === "number";
    return ok ? (p as ItineraryPlan) : undefined;
  } catch {
    return undefined;
  }
}
